import { Link } from "react-router-dom";

export default function Logo({ className = "" }: { className?: string }) {
  return (
    <Link to="/" className={`flex items-center gap-2 cursor-pointer ${className}`} aria-label="桔子TV 首页">
      <span className="w-9 h-9 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center shrink-0">
        <i className="ri-movie-2-fill text-xl" />
      </span>
      <span className="flex flex-col leading-none">
        <span className="font-heading font-extrabold text-lg tracking-tight text-foreground-950">
          桔子<span className="text-primary-500">TV</span>
        </span>
        <span className="text-[10px] tracking-[0.22em] text-foreground-600 font-label">JUZI TV</span>
      </span>
    </Link>
  );
}